import CanalRetail from "./CanalRetail";

export default CanalRetail;
